import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import ClientsPage from "./pages/ClientsPage";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import ESG from "./pages/ESG";
import GivingBack from "./pages/GivingBack";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";

function useReveal() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Re-arm reveal animations on route change
    const t = setTimeout(() => {
      const els = document.querySelectorAll(".reveal:not(.in-view)");
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("in-view");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      els.forEach((el) => io.observe(el));
    }, 50);
    return () => clearTimeout(t);
  }, [pathname]);
}

function Shell() {
  useReveal();
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/news" element={<Blog />} />
        <Route path="/news/:id" element={<BlogDetail />} />
        <Route path="/esg" element={<ESG />} />
        <Route path="/charity" element={<GivingBack />} />
      </Routes>
      <Toaster position="bottom-right" theme="dark" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
